module.exports = __webpack_public_path__ + "static/media/img_feature_photo2.0d3b8ffe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_feature_photo2.webp
// module id = 800
// module chunks = 0